import {Brand, OrganizationBrandsResponse} from '@/types/brand';
import organizationBrandsFetchers from '@/api/fetchers/organizationBrands';
import useDataQuery from '@/hooks/use-data-query';

type UseOrganizationBrandsQueryProps = {
  brandId?: string | null;
  enabled?: boolean;
};

type UseOrganizationBrandsQueryReturn = {
  brands: Brand[];
  agencyId?: string;
  isLoading: boolean;
  isError: boolean;
  refetch: () => void;
};

function useOrganizationBrandsQuery({
  brandId,
  enabled = true,
}: UseOrganizationBrandsQueryProps): UseOrganizationBrandsQueryReturn {
  const response = useDataQuery<OrganizationBrandsResponse>({
    queryKey: ['organizationBrands', brandId],
    queryFn: organizationBrandsFetchers.organizationBrands,
    enabled: !!brandId && enabled,
    refetchOnWindowFocus: false,
    meta: {
      brandId,
    },
  });

  const data = response.data as OrganizationBrandsResponse | undefined;

  const brands = data?.brands || [];

  const agencyId = data?.id;

  return {
    ...response,
    brands,
    agencyId,
  };
}

export default useOrganizationBrandsQuery;
